import { StrmClassState } from "explorer/reducers/strm-class";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { ReactComponent as Logo } from "shared/assets/images/logo-strm.svg";
import { StrmClassVideo } from "shared/interfaces/StrmClassVideo";
import { Divider, Typography } from "antd";
import { isDesktop } from "react-device-detect";
import "./StrmClass.scss";

const StrmClassDetail: React.FC<RouteComponentProps> = (props) => {
  const { match } = props;
  const {
    params: { id },
  }: any = match;
  const [videoInfo, setVideoInfo] = useState<StrmClassVideo>();
  const { videos } = useSelector((state: StrmClassState) => state.strmClass);
  // const relatedVideos = useMemo(() => {
  //   const tags = videoInfo?.tags || [];

  //   return videos.filter((v) => {
  //     return v.tags.some((tag) => tags.includes(tag));
  //   });
  // }, [videoInfo]);

  useEffect(() => {
    if (videos.length > 0) {
      const video = videos.find((v) => v.id === id);
      setVideoInfo(video);
    }
  }, [id, videos]);

  if (videoInfo) {
    return (
      <div className={`strm-class margin ${isDesktop ? "web" : ""}`}>
        <div className="logo">
          <Logo /> class
        </div>
        <div className="video-container">
          <iframe
            src={videoInfo.videoUrl}
            title="strm-class"
            className="iframe-video"
          />
        </div>
        <Typography.Title level={2} className="title">
          {videoInfo.title}
        </Typography.Title>
        <Typography.Paragraph className="paragraph">
          {videoInfo.subtitle}
        </Typography.Paragraph>
        <Divider />
      </div>
    );
  }

  return (
    <div className={`strm-class margin ${isDesktop ? "web" : ""}`}>
      <div className="logo">
        <Logo /> class
      </div>
    </div>
  );
};

export default StrmClassDetail;
